import { useEffect } from 'react';
import { REACT_APP_SF_SALES_CHAT_URL, SALESFORCE_CHAT_ORG_ID, SALESFORCE_CHAT_SCRT2_URL, SALESFORCE_SALES_DEPLOYMENT_NAME, SALESFORCE_SALES_SCRIPT_SRC } from '../config';

// Extend Window interface
declare global {
  interface Window {
    embeddedservice_bootstrap: any;
    sfChatReady?: boolean;
  }
}

const SalesforceChatNew = () => {
  useEffect(() => {
    //  If script is already added → don't load again
    if (document.getElementById('sf-embedded-script')) return;

    // Configuration mapping
    const selectedConfig = {
        scriptSrc: SALESFORCE_SALES_SCRIPT_SRC,
        deploymentName: SALESFORCE_SALES_DEPLOYMENT_NAME,
        chatUrl: REACT_APP_SF_SALES_CHAT_URL,
    };

    // Inject script
    const script = document.createElement('script');
    script.id = 'sf-embedded-script';
    script.type = 'text/javascript';
    script.src = selectedConfig.scriptSrc;

    script.onload = () => {
      try {
      window.embeddedservice_bootstrap.settings.language = 'en_US';

      window.embeddedservice_bootstrap.init(
        SALESFORCE_CHAT_ORG_ID,
        selectedConfig.deploymentName,
        selectedConfig.chatUrl,
        {
          scrt2URL: SALESFORCE_CHAT_SCRT2_URL,
        }
      );

      // Poll until open() becomes available
      const interval = setInterval(() => {
        if (
          window.embeddedservice_bootstrap &&
          typeof window.embeddedservice_bootstrap.open === 'function'
        ) {
          window.sfChatReady = true;
          clearInterval(interval);
        }
      }, 300);
    } catch (error) {
      console.error('Error loading Salesforce Embedded Messaging:', error);
    }
  };


    document.body.appendChild(script);

    return () => {
      const existingScript = document.getElementById('sf-embedded-script');
      if (existingScript) existingScript.remove();
    };
  }, []);

  return null;
};

export { SalesforceChatNew };
